export * from "./lib/SparqlJsonParser";
